import { render, staticRenderFns } from "./Storetable.vue?vue&type=template&id=04bff94a&scoped=true"
import script from "./Storetable.vue?vue&type=script&lang=js"
export * from "./Storetable.vue?vue&type=script&lang=js"
import style0 from "./Storetable.vue?vue&type=style&index=0&id=04bff94a&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bff94a",
  null
  
)

export default component.exports